<template>

    <div
        class="xc-modal xc-modal-confirm"
        v-if="isShow"
    >
        <div class="xc-modal-mask"></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div
                        class="xc-modal-title"
                        v-if="text.title"
                    >{{text.title}}</div>
                    <div
                        class="xc-modal-close"
                        @click="close()"
                    >
                    </div>
                </div>
                <div class="xc-modal-body xc-flex-center">
                    {{text.msg}}
                </div>
                <div class="xc-modal-footer xc-flex-center">
                    <div class="xc-btn-group">
                        <button
                            class="xc-btn xc-btn-default"
                            @click="close()"
                            v-if="text.btn.no"
                        >{{text.btn.no}}</button>
                        <button
                            class="xc-btn xc-btn-primary"
                            @click="ok()"
                            v-if="text.btn.ok"
                        >{{text.btn.ok}}</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'xcConfirm',
    data() {
        return {
            isShow: true,
            text: {
                title: '提示',
                msg: '提示内容',
                btn: {
                    ok: '确定',
                    no: '取消'
                },
            }
        }
    },
    methods: {
        close() {
            this.isShow = false;
        },
        ok() {
            this.close();
        }
    }
}
</script>
<style scoped>
</style>
